export default {
    small: 769,
    medium: 1024,
    large: 1216
}
